<template>
	<v-autocomplete
		v-model="selectedPlace"
		:label="title"
		:items="mSearchResults"
		item-text="place_name"
		item-value="id"
		:prepend-icon="icon"
		return-object
		:loading="loading"
		:search-input.sync="search"
		cache-items
		clearable
		flat no-filter
		hide-no-data
		:append-outer-icon="useGeolocation ? 'location_searching' : 'location_disabled'"
		@click:append-outer="() => (getGeolocation())"
		@change="autocompleteChanged()"
	>
	</v-autocomplete>
</template>
<script>
	import axios from 'axios'
	import _ from 'lodash'

	import { eventBus } from '../main'

	export default {
		name: "MapboxAutocomplete", 
		props: {
			icon: {
        type: String,
        default: 'location_on'
      },
      title: {
        type: String, 
        default: ''
      }
		},
		data() {
			return {
				mSearchResults: [
					{
						place_name: "Current Location", 
						id: 9999
					}
				], 
				selectedPlace: null,
				loading: false,
				search: null, 
				location: {}, 
				useGeolocation: false,
			}
		}, 
		watch: {
			search(value){
				this.geolocate( (location) => {
	        eventBus.$emit('geolocated', {lat: location.lat, lng: location.lng });
	      });

	      this.debouncedGetMapboxLocations();
			}
		},
		methods: {
			geolocate(callback = null){
        if (navigator.geolocation) {
          var options = {enableHighAccuracy: true};

          navigator.geolocation.getCurrentPosition(position => {
              let locationInformation = {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude, 
                  accuracy: position.coords.accuracy
              };

              if (callback) callback(locationInformation);
          }, err => {
            this.$emit('error', 'Cannot get Coordinates from navigator', err);
          }, options);
        }
      },
      autocompleteChanged(){
      	if(this.selectedPlace !== undefined){
      		console.log('Place changed! It\'s '+this.selectedPlace.place_name)
      		// Need to emit an event for the parent to receive and process the change
      	}
      },
      getGeolocation(){
      	this.geolocate( (location) => {
      		this.useGeolocation = !this.useGeolocation;
      		this.selectedPlace = {place_name: "Current Location", id: 9999}
      	})
      	
      },
			handleLocationUpdate(location){
        this.location = location
      },
      getMapboxLocations(){
      	if ( this.search == null || this.search.length < 3 || (this.search.indexOf('current') >= 0 && this.search.indexOf('location') >= 0 ) ) return

      	if ( this.search !== null && this.search.split(',').length > 2) return

        if ( this.location.lat === undefined ) {
        	let snackbar = {
        		text: 'We don\'t know where you are. Please allow location access.',
        		color: 'error'
					}

        	eventBus.$emit('snackAlert', snackbar);
        } 

        this.loading = true

        let query = encodeURI(this.search.replace(' ', '+'))
        let url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'+query+'.json?access_token=pk.eyJ1IjoianVzdGlubXNoZXAiLCJhIjoiY2pndWU4d3F4MjBpMDJ5bWw0eGY0NWd4NyJ9.A74zFyt3xEDTM_4R_oE7nw&autocomplete=true&country=us&types=place%2Cpoi&proximity='+this.location.lng+'%2C'+this.location.lat;

        console.log(url)

        axios.get(url)
          .then(res => { 
            var {features} = res.data
            this.mSearchResults = features
          })
          .then(()=>{
          	this.loading = false	
          })
          .catch(error => {
            console.log(error)
          })
      }
		}, 
		created() {
			this.debouncedGetMapboxLocations = _.debounce(this.getMapboxLocations, 450)

			eventBus.$on('geolocated', location => {
				this.handleLocationUpdate(location)
			})
		}
	}
	
</script>
<style>
	
</style>